// extracted by mini-css-extract-plugin
export default {"root":"T_DM932uP6alIdM9bgzz","week":"Qxi1pYchI7BRWZhA9mAR","weekSelected":"_OGXesrpTLSxFVd3_R8v","placeHolderShimmer":"zFwMvjv87jIapZ8b0joS"};